import React from 'react'

import { AddressElement } from './address-with-highlighted-fields.styles'

import type { Address } from '~/types'

type Props = {
  address: Address
  highlightedFields?: Array<string>
  className?: string
}

export default function AddressWithHighlightedFields({
  address,
  highlightedFields = [],
  className,
}: Props) {
  const AddressLine = ({ keys }) => {
    const nonEmptyAddressKeys = keys.filter((key) => address[key])
    if (nonEmptyAddressKeys.length === 0) return null

    return (
      <div>
        {nonEmptyAddressKeys
          .map((key) => (
            <AddressElement
              key={key}
              id={key}
              $highlighted={highlightedFields.includes(key)}
            >
              {address[key]}
            </AddressElement>
          ))
          .reduce((prev, curr) => [prev, ', ', curr])}
      </div>
    )
  }

  return (
    <div className={className}>
      <AddressLine keys={['street1']} />
      <AddressLine keys={['city', 'stateProvince']} />
      <AddressLine keys={['country', 'zipPostal']} />
    </div>
  )
}
